let axiosInstance = null;

async function getAxios() {
  if (axiosInstance) return axiosInstance;

  if (process.env.NODE_ENV === "test") {
    axiosInstance = {
      get: async () => ({ data: {} }),
    };
  } else {
    const mod = await import("axios");
    axiosInstance = mod.default;
  }

  return axiosInstance;
}

export default getAxios;
